// extracted by mini-css-extract-plugin
export default {"toggleMetrics":"style_toggleMetrics__fCpE5","toggleInput":"style_toggleInput__+cAeX","icon":"style_icon__YYqIn","slider":"style_slider__53eY9"};